module.exports = __webpack_public_path__ + "img/branch-roles.eef37244.svg";